import { useEffect, useState, createContext, useContext } from 'react';
import { publicApi } from '@/lib/api';

const MaintenanceContext = createContext({ isMaintenanceMode: false, loading: true });

export function MaintenanceProvider({ children }) {
  const [state, setState] = useState({ isMaintenanceMode: false, loading: true });

  useEffect(() => {
    publicApi.getMaintenanceInfo()
      .then(r => setState({ isMaintenanceMode: !!r.data.maintenance_mode, loading: false }))
      .catch(() => setState({ isMaintenanceMode: false, loading: false }));
  }, []);

  return (
    <MaintenanceContext.Provider value={state}>
      {children}
    </MaintenanceContext.Provider>
  );
}

export function useMaintenance() {
  return useContext(MaintenanceContext);
}
